import { render } from "./Step1.vue?vue&type=template&id=604e1b1e&scoped=true"
import script from "./Step1.vue?vue&type=script&lang=ts"
export * from "./Step1.vue?vue&type=script&lang=ts"

import "./Step1.vue?vue&type=style&index=0&id=604e1b1e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-604e1b1e"

export default script